import { call, put, select } from 'redux-saga/effects'
import api from '../../../../services/api'
import * as Actions from './actions'

export function* searchRequest() {
    try {
        let client = yield call(api, 'protocolo');
        let { filtros } = yield select(state => state.protocoloExcluir);

        let filter = {};

        for (const [key, value] of Object.entries(filtros)) {
            if(value !== "") filter[key] = value;
        }
        let body = { filter: filter }

        let response = yield call(client.post, `/consulta/exec/exclusao_protocolo`, body);
        let total_protocolos = []

        /* Pegar o total de protocolos */
        if(response.data.length > 0) {
            const dist_protocolos = response.data.map(item => item.protocolo).filter((value, index, self) => self.indexOf(value) === index);
            for(let c = 0; c < dist_protocolos.length; c++) {
                let prot = dist_protocolos[c]
                let response_total = yield call(client.post, `/consulta/exec/exclusao_protocolo`, { filter: { "protocolo.numero": prot }});
                total_protocolos[prot] = response_total.data.length
            }
        }

        let payload = {
            protocolos: response.data,
            total_protocolos: total_protocolos
        }

        yield put(Actions.searchSuccess(payload));
    } catch (error) {
        yield put(Actions.searchFailure(error));
    }
}

export function* searchReasonRequest() {
    try {

        /*
        let client = yield call(api, 'protocolo');
        let response = yield call(client.get, `motivoProtocolo`);
        */

        const response = [
            {
              codigo: 3,
              unico: false,
              nome: "Inclusão de contrato errado"
            },
            {
                codigo: 1,
                unico: true,
                nome: "Numero de envelope errado"
            },
            {
                codigo: 2,
                unico: false,
                nome: "Envelope extraviado, necessário novo protocolo"
            },
            {
                codigo: 4,
                unico: false,
                nome: "Outros"
            }
        ]

        yield put(Actions.searchReasonSuccess(response));
    } catch (error) {
        yield put(Actions.searchReasonFailure(error));
    }
}

export function* deleteRequest( { body } ) {
    try {
        const { listaContratos, motivo, observacao } = body;
        const payload = {
            contratos: listaContratos,
            motivo,
            observacao,
        };

        const client = yield call(api, 'protocolo');
        const response = yield call(client.post, 'protocolo-exclusao', payload);

        yield put(Actions.removeContrato(response.data.message));
    } catch (error) {
        yield put(Actions.deleteFailure(error));
    }
}

export function* deleteProtocolRequest() {
    try {
        let client = yield call(api, 'protocolo');
        let response = yield call(client.get, `protocolo/excluir-protocolo`);

        yield put(Actions.removeProtocolo(response.data));
    } catch (error) {
        yield put(Actions.deleteProtocolFailure(error));
    }
}

export function* removerContratoDoProtocolo({ payload: { contrato, onSuccess, onError } }) {
    try {
        let client = yield call(api, 'protocolo');
        let response = yield call(client.post, `protocolo-exclusao`, {
            idcontratos: [
                contrato.IdContrato,
            ],
            motivos: 'Alteração do Protocolo Principal deste contrato',
            observacao: 'Remoção atravez da tela de protocolar',
        });

        onSuccess();
    } catch (error) {
        onError(error);
    }
}
